(function(){
    angular.module('tmx-app').directive('tmxQuestion',tmxQuestion);
/*
https://github.com/danialfarid/ng-file-upload
refer to above URL for documentation of the fileuploading library used	
*/
    function tmxQuestion(){
        var directive={};
        directive.scope={
            name:'@',
            selected:'=',
            required:'@',
            question:'@',
            answers:'=',
            answerTextAttr:'@',
            answerValueAttr:'@',
            onChange:'&',
            score:'=',
            hasDisabledExpression:'@',
            readonly:'@',
            disabled:'=',
            dynamicField:'=',
        };
        directive.restrict='E';
        directive.templateUrl='common/directives/tmxquestion/tmxquestion.html';
        directive.controller=["$scope","tmxUtility",questionCtrl];
        directive.controllerAs="questionCtrl";
        return directive;
    }
	
    var exists;

    function questionCtrl($scope,tmxUtility){
        exists=tmxUtility.exists;
        $scope.label="Please Select";
        $scope.formattedAnswers=formatAnswers($scope.answers,$scope.answerTextAttr,$scope.answerValueAttr);
        $scope.updateScore=function(value){
            updateScore(value,$scope,$scope.formattedAnswers);
            onchange($scope,value);
        };
        if(!exists($scope.disabled)){
            $scope.disabled=false;
        }
        if(exists($scope.hasDisabledExpression) && $scope.hasDisabledExpression == "true"){
        	bindDisablilityWithFormula($scope);
        }
    }

    function onchange($scope,value){
        if(angular.isFunction($scope.onChange())){
            $scope.onChange()(value,$scope);
        }
    }

    function formatAnswers(answers,textAttr,valueAttr){
        var formattedAnswers=[];
        answers.forEach(function(answer){
            formattedAnswers.push({VisibleValue:answer[textAttr],HiddenValue:answer[valueAttr],score:answer["ResponseScoreValue"]});
        });
        return formattedAnswers;
    }

    function updateScore(value,scope,answers){
        var selected=answers.filter(function(answer){return answer.HiddenValue==value})[0];
        if(exists(selected,"score"))
            scope.score=selected.score;	
        else 
            scope.score=0;
    }
	 

    function bindDisablilityWithFormula(scope){
        function get(){
		  return scope.readonly;
        }

        function update(f1,f2){
		  //if(f1!=f2){
		    if(f1=="true"){
		    	delete scope.value;
		    	scope.disabled=true;
		    }
		    else
		    	scope.disabled=false;
		  }
		//}

        scope.$watch(get,update);
    }

})();